import { types } from 'mobx-state-tree';
import StructuredDataOrg from "./StructuredDataOrg";
import StructuredDataWebsite from "./StructuredDataWebsite";

export default types.model('StructuredData', {
    Organization: types.maybeNull(StructuredDataOrg),
    Website: types.maybeNull(StructuredDataWebsite)
}).views(self => ({

})).actions(self => ({
	
}));
